import './Footer.css';
import github from '../../../images/social/github-white.png';
import facebook from '../../../images/social/facebook-white.png';
import twitter from '../../../images/social/twitter-white.png';
import linkedIn from '../../../images/social/linkedIn-white.png';

const centerDiv = 'd-flex justify-content-center align-items-center';

export const part1 = (
    <div className={centerDiv}>
        <div className="footerSec">
            <h3>Links</h3>
            <li>See my resume</li>
            <li>Download my resume</li>
            <li>Navigate to my projects</li>
            <li>Contact with me</li>
            <li>Know about me</li>
        </div>
    </div>
)

export const part2 = (
    <div className={centerDiv}>
        <div className="footerSec right-footer">
            <h3>Social</h3>
            <div>
                <img src={facebook} alt="" />
                <li><a className="anchor" href="https://www.facebook.com/naim.morshed.1" target="_blank">on Facebook</a></li>
            </div>
            <div>
                <img src={linkedIn} alt="" />
                <li><a className="anchor" href="https://www.linkedin.com/in/naim-morshed-3a30b8178/" target="_blank">on LinkedIn</a></li>
            </div>
            <div>
                <img src={github} alt="" />
                <li><a className="anchor" href="https://github.com/NaimMorshed" target="_blank">on Github</a></li>
            </div>
            <div>
                <img src={twitter} alt=""/>
                <li><li><a className="anchor" href="https://twitter.com/naimpritom" target="_blank">on Twitter</a></li></li>
            </div>
        </div>
    </div>
)